import React, { useState } from "react";
import { getPriorityColor, getStatusColor } from "../../utils/colors";

export const WorkflowsTab = ({ filteredWorkflows }) => {
    const [selectedWorkflow, setSelectedWorkflow] = useState(null);

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            {filteredWorkflows.map((workflow) => (
                <div
                    key={workflow.id}
                    className="flex flex-col justify-between bg-white rounded-lg shadow-sm border border-gray-200 p-2 h-full"
                >
                    <div className="flex items-start justify-between mb-4">
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 break-words">
                                {workflow.name}
                            </h3>
                            <p className="text-sm text-gray-500 break-words">
                                {workflow.description}
                            </p>
                        </div>
                        <span
                            className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                                workflow.status
                            )}`}
                        >
                            {workflow.status}
                        </span>
                    </div>

                    <div className="space-y-3 mb-4">
                        <div className="flex justify-between items-center">
                            <span className="text-sm text-gray-600">Progress</span>
                            <span className="text-sm font-medium">
                                {workflow.completedTasks || 0}/{workflow.tasks.length} tasks
                            </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                            <div
                                className="bg-blue-600 h-2 rounded-full"
                                style={{
                                    width: `${(workflow.completedTasks / workflow.tasks.length) * 100
                                        }%`,
                                }}
                            ></div>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <span className="text-sm text-gray-600">Category</span>
                            <p className="font-medium break-words">{workflow.category}</p>
                        </div>
                        <div>
                            <span className="text-sm text-gray-600">Due Date</span>
                            <p className="font-medium">{workflow.dueDate}</p>
                        </div>
                    </div>

                    <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                        <div className="flex -space-x-2">
                            {workflow?.assignedTo?.map((person, index) => (
                                <div
                                    key={index}
                                    className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white text-xs font-medium border-2 border-white"
                                >
                                    {person
                                        .split(" ")
                                        .map((n) => n[0])
                                        .join("")}
                                </div>
                            ))}
                        </div>
                        <div className="flex space-x-2">
                            <button
                                onClick={() => setSelectedWorkflow(workflow)}
                                className="text-blue-600 hover:text-blue-800 text-sm"
                            >
                                View Tasks
                            </button>
                        </div>
                    </div>
                </div>
            ))}

            {selectedWorkflow && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    onClick={() => setSelectedWorkflow(null)}
                >
                    <div
                        className="bg-white rounded-lg shadow-lg w-full max-w-4xl p-6 relative overflow-y-auto max-h-[80vh]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={() => setSelectedWorkflow(null)}
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl"
                        >
                            ✕
                        </button>

                        <h2 className="text-xl font-semibold mb-4 text-gray-900">
                            {selectedWorkflow.name} — Tasks
                        </h2>

                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left border border-gray-200 rounded-lg overflow-hidden">
                                <thead className="bg-gray-100 text-gray-700">
                                    <tr>
                                        <th className="px-3 py-2 border-b">Title</th>
                                        <th className="px-3 py-2 border-b">Description</th>
                                        <th className="px-3 py-2 border-b">Priority</th>
                                        <th className="px-3 py-2 border-b">Status</th>
                                        <th className="px-3 py-2 border-b">Start Date</th>
                                        <th className="px-3 py-2 border-b">Due Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedWorkflow.tasks.map((task) => (
                                        <tr key={task.id} className="border-b hover:bg-gray-50">
                                            <td className="px-3 py-2 break-words">{task.title}</td>
                                            <td className="px-3 py-2 break-words">
                                                {task.description}
                                            </td>
                                            <td className="px-3 py-2">
                                                <span
                                                    className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(
                                                        task.priority
                                                    )}`}
                                                >
                                                    {task.priority}
                                                </span>
                                            </td>

                                            <td className="px-3 py-2">
                                                <span
                                                    className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                                                        task.status
                                                    )}`}
                                                >
                                                    {task.status}
                                                </span>
                                            </td>

                                            <td className="px-3 py-2">{task.startDate}</td>
                                            <td className="px-3 py-2">{task.dueDate}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
